import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.deposit_match.edit', [])
  .controller('DepositMatchEditCtrl', DepositMatchEditCtrl)

/** @ngInject */
function DepositMatchEditCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  DepositMatchService,
  EventService,
  UploadService,
  CouponsService,
) {
  var vm = this

  vm.model = {}
  vm.pathImgThumb = ''
  vm.pathImgLarge = ''
  vm.pathImgLargeBack = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false
  vm.channels = []
  vm.depositSegmentations = []

  CouponsService.listPublished(0, 1000).then(function (result) {
    vm.coupons = result.results
  })

  DepositMatchService.listOfferSegmentation($stateParams.id).then(function (result) {
    vm.depositSegmentations = result.results
  })

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  EventService.listChannels().then(function (result) {
    vm.channels = result.results
  })

  function load() {
    if (vm.id !== '0') {
      DepositMatchService.get(vm.id).then(function (result) {
        vm.model = result.results
        if (vm.model['ts-start']) {
          vm.model['ts-start'] = vm.model['ts-start'] / 1000
          vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
          vm.data1 = angular.copy(vm.model['ts-start'])
        }

        if (vm.model['ts-end']) {
          vm.model['ts-end'] = vm.model['ts-end'] / 1000
          vm.model['ts-end'] = new Date(parseInt(vm.model['ts-end']))
          vm.data2 = angular.copy(vm.model['ts-end'])
        }
      })
    }
  }

  load()

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-end'] = null
    }

    if (isUpdate) {
      DepositMatchService.update(model.id, model).then(
        function (result) {
          $state.go('admin.deposit_match')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    } else {
      DepositMatchService.create(model).then(
        function (result) {
          $state.go('admin.deposit_match')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.deposit_match')
  }

  vm.uploadThumb = function (item) {
    if (vm.pathImgThumb.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadThumb = true
    UploadService.save('collectibles', vm.pathImgThumb, 'img-t', item.id).then(function (fileName) {
      vm.loadThumb = false
      item['img-t'] = fileName
    })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })

  vm.openCalendar1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.addSegmentation = function () {
    vm.segmentationId = parseInt($('#e15').select2('val'))

    DepositMatchService.addOfferSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        DepositMatchService.listOfferSegmentation($stateParams.id).then(function (result) {
          vm.depositSegmentations = result.results
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DepositMatchService.removeOfferSegmentation($stateParams.id, id).then(function () {
            DepositMatchService.listOfferSegmentation($stateParams.id).then(function (result) {
              vm.depositSegmentations = result.results
            })
          })
        }
      },
    )
  }
}
